import gql from 'graphql-tag';

export default gql`
  mutation resetUserPasswordsAdmin($ids: [UUID!]!) {
    resetUserPasswordsAdmin(_ids: $ids)
  }
`;
